export const messageInfo = {
  "content":"内容",
  "sendTime":"发送时间",
};
